import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcoIconComponent, EcoIconName } from './eco-icon.component';

export interface EcoCard {
  id: string;
  title: string;
  desc: string;
  icon: EcoIconName;
  /** Drives the neon accent of the icon + border. */
  tone?: 'pink' | 'violet' | 'blue';
}

@Component({
  selector: 'app-eco-card',
  standalone: true,
  imports: [CommonModule, EcoIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './eco-card.component.html',
  styleUrls: ['./eco-card.component.scss'],
})
export class EcoCardComponent {
  @Input({ required: true }) card!: EcoCard;
  /** `step` stacks the icon above the text for the bottom process flow. */
  @Input() variant: 'default' | 'compact' | 'step' = 'default';
}
